<section class="bg-half-170 d-table w-100" id="home"
         style="background: url({{pack.url}}) center center; background-size: cover">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-7 col-md-6">
                <div class="title-heading mt-4">
                    <h1 class="display-4 font-weight-bold text-white title-dark mb-3">{{pack.packageName}}</h1>
                    <p class="para-desc text-white-50">We arrange inbound journeys to Sri Lanka from a vast number of
                        international locations. We always thrive to cater to the travel preferences of each client and
                        have excellent relationships with repeat clients.</p>
                    <div class="mt-4">
                        <button class="btn btn-primary mb-2" (click)="book()">Book now</button>
                    </div>
                </div>
            </div>
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>
<section class="section">
    <div class="container">
        <!--        <div class="row">-->
        <!--            <div class="col-lg-4 col-md-6">-->
        <!--                <img class="rounded" src="{{pack.url}}" style="height: 16rem; width: 20rem;" alt="">-->
        <!--            </div>-->
        <!--            <div class="col-lg-6 col-md-6" style="padding-top: 75px;">-->
        <!--                <h4><b>{{pack.packageName}}</b></h4>-->
        <!--                <p class="text-muted">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem-->
        <!--                    Ipsum has been the industry's standard dummy text ever since the 1500s</p>-->
        <!--                <button class="btn btn-primary mb-2" (click)="book()">Book now</button>-->
        <!--            </div>-->
        <!--            <p class="text-muted"></p>-->
        <!--        </div>-->

        <div class="row mt-5" *ngIf="pack.travelType.type !='Outbound'">
            <div class="col-12">
                <h2><b>ITENARY</b></h2>
            </div>
            <div class="row" style="width: 100%">
                <!--                <div class="col-3"></div>-->
                <!--                <div class="col-lg-12 mt-4 pt-2" *ngFor="let i of pack.itenary">-->
                <!--                    <div class="card shadow rounded border-0 overflow-hidden">-->
                <!--                        <div class="row g-0">-->
                <!--                            <div class="col-md-3">-->
                <!--                                <img style="height: 16rem;" src="{{i.url}}" alt="..." class="img-fluid"></div>-->
                <!--                            <div class="col-md-9">-->
                <!--                                <div class="card-body"><h5-->
                <!--                                        class="card-title">{{i.description}}</h5>-->
                <!--                                    <p class="text-muted" *ngFor="let d of i.packageIternaryDetailsList">-->
                <!--                                        {{d.description}}-->
                <!--                                    </p>-->
                <!--                                    <p class="card-text"><small-->
                <!--                                            class="text-muted">Last updated 3-->
                <!--                                        mins ago</small></p></div>-->
                <!--                            </div>-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->

                <div class="blog-card" *ngFor="let i of pack.itenary" style="width: 100%">
                    <div class="meta">
                        <div class="photo" style="background-image: url({{i.url}})"></div>
                        <ul class="details">
                        </ul>
                    </div>
                    <div class="description">
                        <h1>{{i.description}}</h1>
                        <h2>Itenary details</h2>
                        <p *ngFor="let d of i.packageIternaryDetailsList">{{d.description}}</p>
                        <p class="read-more">
                            <!--                            <a href="#">Read More</a>-->
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-5">

            <div  class="card col-12 " style=" box-shadow: 0 3px 7px -1px rgba(0, 0, 0, .1);" *ngIf="pack.exclusionsList.length !=0 && pack.exclusionsList.length !=0">
                <div class="card-body" >
                    <h2 *ngIf="pack.exclusionsList.length !=0">Exclusions</h2>
                    <ul class="check-list">
                        <li *ngFor="let p of pack.exclusionsList">{{p.description}}</li>
                    </ul>
                    <h2 *ngIf="pack.inclusionsList.length !=0" >Inclusions</h2>
                    <ul class="check-list">
                        <li *ngFor="let p of pack.inclusionsList">{{p.description}}</li>
                    </ul>
                </div>
            </div>

        </div>

        <div class="row mt-5">
<!--            <div class="card col-12">-->
<!--                <div class="card-body">-->

<!--                </div>-->
<!--            </div>-->


            <!--            <div class="col-xl-4 col-lg-4 mb-3" *ngFor="let p of pack.inclusionsList" [hidden]="p.status==9">-->
            <!--                <div class="card img shadow-md" style=" background: url({{p.url}});border-radius: 10px">-->
            <!--                    <div class="bg-overlay" style="border-radius: 10px"></div>-->
            <!--                    <div class="card-body">-->
            <!--                        <div class="row">-->
            <!--                            <div class="col-12">-->
            <!--                                <h4 style="color: white">{{p.description}}</h4>-->
            <!--                            </div>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </div>-->

            <!--            </div>-->
        </div>
    </div>
</section>
